import { Button } from '@chakra-ui/react';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { utils, writeFile } from 'xlsx';

import { date as commonDate } from '@finley-technologies/common';
import { Bank } from '@finley-technologies/finley-types';

import { TaskFragmentGQLType } from 'types/dashboard-core-gqlTypes.generated.d';

import {
  taskStatuses,
  getActionRequiredFromCategorySpecificProperties,
  getDueDateFromCategorySpecificProperties,
  getLoanIdFromCategorySpecificProperties,
} from './common';
import {
  truncateUuid,
  formatCurrencyAmount,
} from 'packages/common-frontend/utils';

export const DownloadTaskCenterButton = ({
  tasksByStatus,
}: {
  tasksByStatus: { [key: string]: TaskFragmentGQLType[] };
}) => {
  // download add data into excel book
  const exportToXlsx = useCallback(() => {
    if (tasksByStatus) {
      const todayFullDateStr = commonDate.currentDateStr();

      const wb = utils.book_new();

      taskStatuses.forEach((status) => {
        const tasksForStatus = tasksByStatus[status];

        if (tasksForStatus) {
          const dataForTask = tasksForStatus.map((t) => {
            const loanId = getLoanIdFromCategorySpecificProperties(
              t.domainProperties.categorySpecificProperties,
            );

            return {
              // this should be the same as the columnDefs for the tanstack tables in the child component
              creditFacilityName: _.startCase(
                t.domainProperties.creditFacility.name,
              ),
              loanId: loanId ? truncateUuid(loanId) : '-',
              category: _.startCase(
                t.domainProperties.categorySpecificProperties.category,
              ),
              actionRequired: getActionRequiredFromCategorySpecificProperties(
                t.domainProperties.categorySpecificProperties,
              ),
              amount: formatCurrencyAmount(
                t.domainProperties.amount,
                Bank.Currency.USD,
              ),
              partyName: _.startCase(t.domainProperties.party.name),
              dueDate:
                getDueDateFromCategorySpecificProperties(
                  t.domainProperties.categorySpecificProperties,
                ) ?? '-',
            };
          });

          const ws = utils.json_to_sheet(dataForTask);
          utils.book_append_sheet(wb, ws, status);
        }
      });

      writeFile(wb, `task-center-${todayFullDateStr}.xlsx`);
    }
  }, [tasksByStatus]);

  return (
    <Button variant="secondary" colorScheme="v2-aurora" onClick={exportToXlsx}>
      Download XLSX
    </Button>
  );
};
